import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3Ubicacion } from "../Maestro/Ubicacion/M3Ubicacion.type";

export class M3Trx {

    //Obtener informacion del diario de transacciones desde servicio rest M3Trx. Microservicio M3.
    public M3_GetDiario(PostServiceM3: PostServiceM3, sIDKatios: string, oDataSend: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3Trx/M3_GetDiario/' + sIDKatios, oDataSend).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var oDataDiario;
            oDataDiario = resp;
            if (oDataDiario.RESPUESTA.data.length === undefined) {
                oDataDiario.RESPUESTA.data = new Array(oDataDiario.RESPUESTA.data);
            }
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }

    /**
     * Retorna el diario de transacciones detallado
     * @param PostServiceM3 
     * @param sIDKatios 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public m3_getDiarioTrx(PostServiceM3: PostServiceM3, sIDKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3Trx/m3_getDiarioTrx/' + sIDKatios, data).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var oDataDiario;
            oDataDiario = resp;
            if (oDataDiario.RESPUESTA.Diario.length === undefined) {
                oDataDiario.RESPUESTA.Diario = new Array(oDataDiario.RESPUESTA.Diario);
            }
            oFuncionOK(resp);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }

    //Obtener informacion de transaccion.
    public M3_GetInfoTRX(PostServiceM3: PostServiceM3, sIDKatios: string, oDataSend: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        //let data = { 'Top': top };
        PostServiceM3.getWithBodyM3('M3Trx/M3_GetInfoTRX/' + sIDKatios, oDataSend).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var oDataTRX;
            oDataTRX = resp;

            if (oDataTRX.RESPUESTA.TIPOS.length === undefined) {
                oDataTRX.RESPUESTA.TIPOS = new Array(oDataTRX.RESPUESTA.TIPOS);
            }

            oDataTRX.RESPUESTA.TIPOS.forEach(tipo => {
                if (tipo.TRX.length === undefined) {
                    tipo.TRX = new Array(tipo.TRX);
                }
            });


            oFuncionOK(oDataTRX);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }//End 



    //Cambio de estado de ubicacion
    public CambioEstadoUbicacion(PostServiceM3: PostServiceM3, sIDKatios: string, oM3Ubicacion: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.postServiceHttpResFullM3('M3Trx/CambioEstadoUbicacion/' + sIDKatios, oM3Ubicacion).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                console.log(err._body);
                //Ejecutar funcion de error
                oFuncionErr(err._body);
            });
    }//End 


    //Cambio de estado de HUB
    public CambioEstadoHub(PostServiceM3: PostServiceM3, sIDKatios: string, oM3Ubicacion: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.postServiceHttpResFullM3('M3Trx/CambioEstadoHub/' + sIDKatios, oM3Ubicacion).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            oFuncionOK(resp);
        },
            err => {
                console.log(err._body);
                //Ejecutar funcion de error
                oFuncionErr(err._body);
            });
    }//End 

}